package com.shadowings.gero.domain.model

enum class Faces {
    Idle,
    Happy,
    Perfect,
    Sad,
    Cry,
    Surprised,
    Serious,
    Sleeping,
    AllBlack,
    Doubt
}

